import { useQuery } from '@apollo/client'
import { useAccessStore } from 'features/Access/infra/react/AccessState'
import {
  SUBSCRIPTION_NOTICE__GET_SUBSCRIPTION,
  SUBSCRIPTION_NOTICE_QUERY_OPTIONS,
} from 'presentation/main/GlobalNotice/SubscriptionNotice/SubscriptionNotice'
import { get } from 'presentation/utils/graphql'
import { useEffect, useMemo, useRef } from 'react'
import { unmaskFailedInvoiceFragment } from '../FailedInvoiceModal/unmaskFailedInvoiceFragment'
import { openPaymentFailedModal } from './PaymentFailedModal'

export const usePaymentFailedModal = () => {
  const access = useAccessStore(state => state.local.access)
  const { data, loading, error } = useQuery<any>(
    SUBSCRIPTION_NOTICE__GET_SUBSCRIPTION,
    SUBSCRIPTION_NOTICE_QUERY_OPTIONS,
  )
  const openedInvoiceId = useRef<string | null>(null)

  const sub = data?.myEnterprise?.subscription
  const activeSub = get('BillingSubscriptionActive')(sub)

  const failedInvoiceSummary = useMemo(
    () => activeSub ? unmaskFailedInvoiceFragment(activeSub) : null,
    [activeSub],
  )
  const isLegacyPlan = activeSub?.plan?.product?.isLegacy ?? false
  const hasCurrentAccessSubscription
    = (access.status === 'loaded' || access.status === 'updating')
    && access.data.status === 'logged-in'
    && !!access.data.subscription

  const isPastDue = !!failedInvoiceSummary

  useEffect(() => {
    if (loading || error) return

    if (!hasCurrentAccessSubscription) {
      openedInvoiceId.current = null
      return
    }

    if (!failedInvoiceSummary) {
      openedInvoiceId.current = null
      return
    }

    if (openedInvoiceId.current === failedInvoiceSummary.invoiceId) return

    openedInvoiceId.current = failedInvoiceSummary.invoiceId
    openPaymentFailedModal({
      failedInvoiceSummary,
      isLegacyPlan,
    })
  }, [error, failedInvoiceSummary, hasCurrentAccessSubscription, isLegacyPlan, isPastDue, loading])
}
